import axios from 'axios';
import { logout } from '@hotjar/auth';
import type {
  CurrentUser as CurrentUserDTO,
  PartialCurrentUser as PartialCurrentUserDTO,
} from './dto';
import type { CurrentUser as CurrentUserModel, PartialCurrentUser } from './model';
import { currentUserDtoToModel, mapPartialCurrentUserDtoToModel } from './mapper';

const API_ROOT = `/api/v2/users`;

export const CURRENT_USER_API_PATH = `${API_ROOT}/me`;

// type predicate to assert what the api call returns is a current user dto
function isCurrentUserDTO(
  maybeCurrentUser: CurrentUserDTO | Record<string, never>,
): maybeCurrentUser is CurrentUserDTO {
  return 'user_id' in maybeCurrentUser;
}

export async function getUser(userId: number | null): Promise<CurrentUserModel | undefined> {
  if (userId !== null) {
    const response = await axios.get<CurrentUserDTO | Record<string, never>>(
      `/api/v1/users/${userId}`,
    );
    return isCurrentUserDTO(response.data) ? currentUserDtoToModel(response.data) : undefined;
  }

  return undefined;
}

export async function getCurrentUser(): Promise<CurrentUserModel | undefined> {
  const response = await axios.get<CurrentUserDTO | Record<string, never>>(CURRENT_USER_API_PATH);
  if (isCurrentUserDTO(response.data)) {
    return currentUserDtoToModel(response.data);
  }

  // TEMP fix for #_incident-248
  await logout();

  return undefined;
}

export const getPartialCurrentUser = (): Promise<PartialCurrentUser> => {
  return axios
    .get<PartialCurrentUserDTO>(`${API_ROOT}/part-of-me`)
    .then((response) => mapPartialCurrentUserDtoToModel(response.data));
};
